import {
    CreateMatchPlayerCommandOfMatchPlayer,
    EventVm,
    UpdateEventCommand,
} from '../../../../utils/api';
import Exclusion from './Exclusion';

interface OwnProps {
    isHomeTeam: boolean;
    event: UpdateEventCommand;
    lineups: CreateMatchPlayerCommandOfMatchPlayer[];
    events: EventVm[];
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default Exclusion;
